import { CustomSelectFieldProps, SelectField } from 'components/form'
import { useAsyncQuerySelect } from 'components/form/field/select/useAsyncQuerySelect'
import { CertificadoSelectDocument } from 'graphql/hooks.generated'
import { CertificadoSelectQuery, CertificadoSelectQueryVariables } from 'graphql/types.generated'

export type CertificadoSelectModel = CertificadoSelectQuery['certificados']['content'][0]

type CertificadoSelectFieldProps = CustomSelectFieldProps<CertificadoSelectModel>

export function CertificadoSelectField(props: CertificadoSelectFieldProps) {
  const { selectProps } = useAsyncQuerySelect<
    CertificadoSelectModel,
    CertificadoSelectQuery,
    CertificadoSelectQueryVariables
  >({
    query: CertificadoSelectDocument,
    extractItems: (data) => data && data.certificados && data.certificados.content,
    variables: (inputQuery: string) => ({
      input: {
        query: inputQuery,
      },
    }),
  })

  return <SelectField<CertificadoSelectModel> itemToString={itemToString} {...selectProps} {...props} />
}

const itemToString = (option: CertificadoSelectModel | undefined) => option?.nome
